<template>
            <FormModal
            v-if="showTestWebhookForm"
            @cancel="showTestWebhookForm=false"
            @confirm="createTestWebhook()"
            title="Test webhook"
            subtitle="Select an event to test"
            :valid="testEventRequest.eventType != ''"
            submitButtonText="Test event"
        >
        <CustomSelect v-model="testEventRequest.eventType" 
                :options="events" label="Select event" />


        </FormModal>

    <div v-if="webhook != undefined" class="w-full h-full">

        <Header
            title="Wehbooks"
            icon="Webhook"
        />
        <Breadcrumbs
            text1="Webhooks"
            link1="/webhooks"
            :text2="webhook.webhook.id"
            :link2='`/webhooks/${webhook.webhook.id}`'
        >
        </Breadcrumbs>
        <WhiteBox 
            title="Your webhook"
            :subText="webhook.webhook.url"
        >
        <template v-slot:buttons>
                <!-- <CustomButton id="createContract" small text="Send test event" icon="SendHorizontal" type="action" @click="showFormModal=true" /> -->
                <CustomButton v-if="showTestWebhookButton" id="createContract" small text="Test webhook" icon="Send" type="default" 
                :requiresConfirmation="false"
                @click="showTestWebhookForm = true" />
                
                <CustomButton id="createContract" v-if="webhook.webhook.active" small text="Pause" icon="CirclePause" type="action" 
                :requiresConfirmation="true"
                confrimationModalTitle="Pause webhook"
                confrimationModalMessage="Please confirm if you want to pause this webhook"
                confrimationModalButtonText="Pause"
                @confirmClick="deactivateWebhook()" />
                <CustomButton id="createContract" v-if="!webhook.webhook.active" small text="Activate" icon="CirclePlay" type="action"
                :requiresConfirmation="true"
                confrimationModalTitle="Activate webhook"
                confrimationModalMessage="Please confirm if you want to activate this webhook"
                confrimationModalButtonText="Activate"
                @confirmClick="activateWebhook()" />
                <CustomButton id="createContract" small text="Delete" icon="Trash2" type="warning" 
                :requiresConfirmation="true"
                confrimationModalTitle="Delete webhook"
                confrimationModalMessage="Please confirm if you want to delete this webhook"
                confrimationModalButtonText="Delete"
                @confirmClick="deleteWebhook()" />

            </template>
            <template v-slot:content>
                <div class="flex justify-start items-center gap-2">
                    <p class="text-xs font-semibold min-w-[2.5rem]">Status:</p>
                    <div class="border-l pl-2 py-1">
                        <StatusPill
                            v-if="webhook.webhook.active"
                            text="Active"
                            colour="green"
                        />
                        <StatusPill
                            v-else
                            text="Paused"
                            colour="yellow"
                        />
                    </div>
                </div>
                <div class="flex justify-start items-center gap-2">
                    <p class="text-xs font-semibold min-w-[2.5rem]">Secret:</p>
                    <div class="border-l pl-2 py-1 flex items-center gap-2">
                        <StatusPill
                            v-if="showSecret"
                            :text="webhook.webhook.secret"
                            colour="gray"
                        />
                        <CustomButton id="showSecret" small text="Show" icon="Eye" type="default" 
                        v-if="!showSecret"
                        @click="showSecret = true"
                        />
                        <CustomButton id="hideSecret" small text="Hide" icon="EyeOff" type="default" 
                            v-if="showSecret"
                            @click="showSecret = false"
                        />
                    </div>
                </div>
                <div class="flex justify-start items-center gap-2">
                    <p class="text-xs font-semibold min-w-[2.5rem]">Scope:</p>
                    <div class="border-l pl-2 py-1 w-full">
                        <p class="w-full leading-7">
                            <StatusPill
                                v-for="item in webhook.webhook.scope" :key="item"
                                :text="item"
                                colour="gray"
                                class="inline-flex mr-1 text-xs"
                            />
                        </p>
                    </div>
                </div>
            </template>

        </WhiteBox>
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-full xl:col-span-6">
            <WhiteBox title="Event list">
                <template v-slot:content >
                    <EasyDataTable
                    :headers="headersTable1"
                    :items="webhook.webhookEvents.content"
                    :loading="loading"
                    v-model:server-options="serverOptions"
                    :server-items-length="serverItemsLength"
                    :hide-footer="false"
                    :no-hover="false"
                    @click-row="showData"
                    class="cursor-pointer"
                >
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                    <div class="flex justify-center py-4">
                        <div class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                            <p class="text-sm mr-2">No results</p>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                            </svg>
                        </div>
                    </div>
                    </template>
                    <template #item-eventType="eventType">
                        <div class="py-1">
                            <StatusPill
                                :text="eventType.eventType"
                                colour="gray"
                            />
                        </div>
                    </template>
                    <template #item-createdOn="createdOn">
                        <div class="py-1">
                            {{niceDateTime(createdOn.createdOn)}}
                        </div>
                    </template>
                    <template #header-delivered="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
                    <template #item-delivered="delivered">
                        <div class="py-1 flex justify-end">
                            <StatusPill
                                v-if="delivered.delivered"
                                text="Success"
                                colour="green"
                            />
                            <StatusPill
                                v-else
                                text="Failed to deliver"
                                colour="red"
                            />
                        </div>
                    </template>
                </EasyDataTable>
                </template>
            </WhiteBox>
            </div>
            <div class="col-span-full xl:col-span-6" v-if="selectedEvent != undefined">
                <WhiteBox title="Event" :subText="'Created on: ' + niceDateTime(selectedEvent.createdOn)">
                    <template v-slot:buttons>
                        <div v-if="!selectedEvent.delivered" class="p-2"><CustomButton small text="Resend event" @click="resend(selectedEvent)"></CustomButton></div>
                    </template>
                    <template v-slot:content>
                        <div >
                            <p class="text-xs mb-2"> Id: {{selectedEvent.id}}</p>
                            <div class="flex justify-start items-center gap-2 mb-2">
                                <div class="py-1">
                                    <StatusPill
                                        :text="selectedEvent.eventType"
                                        colour="gray"
                                    />
                                </div>
                                <div class="py-1">
                                    <StatusPill
                                        v-if="selectedEvent.delivered"
                                        text="Success"
                                        colour="green"
                                    />
                                    <StatusPill
                                        v-else
                                        text="Failed to deliver"
                                        colour="red"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="py-2 px-3 bg-slate-50 rounded-lg text-xs">
                            <vue-json-pretty v-if="selectedEvent != undefined"  :data="selectedEvent.content" style="font-size: 11px;"/>
                            <p v-else class="text-gray-600">No event selected</p>
                        </div>
                    </template>
                </WhiteBox>
            </div>
            
        </div>

    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
import StatusPill from "@/components/StatusPill.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import Breadcrumbs from "@/components/navbars/Breadcrumbs.vue";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import { DateTime } from 'luxon';
import FormModal from "@/components/modals/FormModal.vue";
import CustomSelect from "@/components/inputs/CustomSelect.vue";



export default {
	name: "manage-publsihers",
	components: {
        Header,
        WhiteBox,
        CustomButton,
        VueJsonPretty,
        Breadcrumbs,
        StatusPill,
        FormModal,
        CustomSelect

	},
	props:{
    },

	data() {
		return {
            webhookId: this.$route.params.webhookId,
            showTestWebhookForm: false,
            showTestWebhookButton: localStorage.getItem('apiType') == process.env.VUE_APP_SANDBOX_API,

            events:[{ id: "CASHBACK_CREATED", text: 'CASHBACK_CREATED' }, 
            { id: "CASHBACK_BEING_VERIFIED", text: 'CASHBACK_BEING_VERIFIED' },
            { id: "CASHBACK_VERIFIED", text: 'CASHBACK_VERIFIED' },
            { id: "CASHBACK_DECLINED", text: 'CASHBACK_DECLINED' },
            { id: "CASHBACK_RECEIVED", text: 'CASHBACK_RECEIVED' },
            { id: "CASHBACK_PAID_TO_PUBLISHER", text: 'CASHBACK_PAID_TO_PUBLISHER' },
            { id: "ACCOUNT_CONNECTED", text: 'ACCOUNT_CONNECTED' },
            { id: "ACCOUNT_DISCONNECTED", text: 'ACCOUNT_DISCONNECTED' },
            { id: "ACCOUNT_EXPIRED", text: 'ACCOUNT_EXPIRED' },
            { id: "ACCOUNT_30_DAY_WARNING", text: 'ACCOUNT_30_DAY_WARNING' },
            { id: "ACCOUNT_14_DAY_WARNING", text: 'ACCOUNT_14_DAY_WARNING' },
            { id: "ACCOUNT_7_DAY_WARNING", text: 'ACCOUNT_7_DAY_WARNING' },
            { id: "ACCOUNT_3_DAY_WARNING", text: 'ACCOUNT_3_DAY_WARNING' },
            { id: "ACCOUNT_1_DAY_WARNING", text: 'ACCOUNT_1_DAY_WARNING' },
            {id:'OFFER_APPROVED',text:'OFFER_APPROVED'},
                {id:'OFFER_REMOVED_FROM_PLATFORM',text:'OFFER_REMOVED_FROM_PLATFORM'},
                {id:'OFFER_REMOVED_FROM_PROGRAM',text:'OFFER_REMOVED_FROM_PROGRAM'},
                {id:'OFFER_UPDATED',text:'OFFER_UPDATED'},
                {id:'OFFER_ACTIVATED',text:'OFFER_ACTIVATED'},
                {id:'OFFER_DEACTIVATED',text:'OFFER_DEACTIVATED'}
            ],

            testEventRequest:{
                eventType:""
            },

            
            webhook:undefined,
            selectedEvent:undefined,
            showSecret: false,
            createAPIKeyRequest:{
                name:""
            },
            serverOptions:{
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength:undefined,
            showErrorModal: false,
            showSuccessModal: false,
            showFormModal: false,
            loading:true,
            headersTable1:[
                { text: "Event", value: "eventType" },
                { text: "Created on", value: "createdOn"}, 
                {text: "Delivery status", value:"delivered"} ,
            ],
            apiKeys:[

            ],
        }
	},
	created(){
        this.getWebhook(0,25)

	},
	methods: {
        niceDateTime(dateObject) {
			return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATETIME_MED)
		},
        showData(data){
            this.selectedEvent = data
        },


        async resend(event){
            try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await fetch(`https://${api}.boogi.io/private/api/client/webhook/${this.webhookId}/event/${event.id}`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
                    this.showTestWebhookForm = false
                    this.getWebhook(0,25)
                    this.selectedEvent = undefined

				}
				
			} catch (error) {
				return;
			}


        },

        async createTestWebhook(){
            try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await fetch(`https://${api}.boogi.io/private/api/client/webhook/${this.webhookId}/test`, {
					method: "POST",
                    body:JSON.stringify(this.testEventRequest),
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					this.testEventRequest.eventType = ""
                    this.showTestWebhookForm = false
                    this.getWebhook(0,25)

				}
				
			} catch (error) {
				return;
			}


        },

        async getWebhook(page,size){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await fetch(`https://${api}.boogi.io/private/api/client/webhook/${this.webhookId}?size=${size}&page=${page}`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()

                    this.webhook = object  
                    this.serverItemsLength =this.webhook.webhookEvents.totalElements
                    this.loading = false
				}
				
			} catch (error) {
				return;
			}

		},

        async deleteWebhook(){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await fetch(`https://${api}.boogi.io/private/api/client/webhook/${this.webhookId}`, {
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					this.$router.push("/webhooks")
				}
				
			} catch (error) {
				return;
			}

		},

        async deactivateWebhook(){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await fetch(`https://${api}.boogi.io/private/api/client/webhook/${this.webhookId}/deactivate`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					this.getWebhook(0,25)
				}
				
			} catch (error) {
				return;
			}

		},

        async activateWebhook(){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await fetch(`https://${api}.boogi.io/private/api/client/webhook/${this.webhookId}/activate`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					this.getWebhook(0,25)
				}
				
			} catch (error) {
				return;
			}

		},





	},
	computed: {

	},
    mounted() {
        document.title = "Dashboard | Webhooks";
    },
    watch: {
        serverOptions: {
            deep: true,
            handler(val){
                     this.getWebhook(val.page-1,val.rowsPerPage)
                }
    }
	}
}
</script>

<style>
.customize-table {
  --easy-table-body-row-background-color: #2d3a4f;
  --easy-table-body-row-hover-background-color: red;
}
</style>